import { css, mediaQueries } from '@eti/styles';
import StackedIcon from '../stacked_icon/StackedIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const titleStyles = css`
  color: #333;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.4375rem;
`;
export const Title = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("h3", {
    className: titleStyles,
    children: children
  });
};
const wrapperStyles = theme => css`
  background: ${theme && `${theme.background.main}`};
  background: ${theme && `linear-gradient(90deg, ${theme.background.accent} 0%, ${theme.background.accent} 1.625rem, ${theme.background.main} 1.625rem, ${theme.background.main} 100%)`};
  border-radius: 0.1875rem;
  box-shadow: 0 0 0.5rem rgb(0 0 0 / 12%);
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 1.25rem 0.625rem;
  position: relative;

  @media ${mediaQueries.large.up} {
    background: ${theme && `linear-gradient(90deg, ${theme.background.accent} 0%, ${theme.background.accent} 2.25rem, ${theme.background.main} 2.25rem, ${theme.background.main} 100%)`};
    padding: 1.25rem 0.75rem;
  }

  [dir='rtl'] & {
    background: ${theme && `linear-gradient(-90deg, ${theme.background.accent} 0%, ${theme.background.accent} 1.625rem, ${theme.background.main} 1.625rem, ${theme.background.main} 100%)`};

    @media ${mediaQueries.large.up} {
      background: ${theme && `linear-gradient(-90deg, ${theme.background.accent} 0%, ${theme.background.accent} 2.25rem, ${theme.background.main} 2.25rem, ${theme.background.main} 100%)`};
    }
  }
`;
export const Wrapper = _ref2 => {
  let {
    children,
    theme,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    ...rest,
    className: wrapperStyles(theme),
    children: children
  });
};
const buttonStyles = css`
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
  position: absolute;
  right: 1rem;
  top: 1rem;

  [dir='rtl'] & {
    left: 1rem;
    right: auto;
  }
`;
export const Button = _ref3 => {
  let {
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/_jsx("button", {
    ...props,
    className: buttonStyles,
    type: "button",
    children: children
  });
};
const notificationIconStyles = css`
  flex: 0 1 2rem;
  height: 2rem;
  margin-right: 0.625rem;
  width: 2rem;

  @media ${mediaQueries.large.up} {
    flex: 0 1 3rem;
    height: 3rem;
    margin-right: 1.375rem;
    width: 3rem;
  }

  [dir='rtl'] & {
    margin-left: 0.625rem;
    margin-right: 0;

    @media ${mediaQueries.large.up} {
      margin-left: 1.375rem;
      margin-right: 0;
    }
  }
`;
export const NotificationIcon = _ref4 => {
  let {
    icons
  } = _ref4;
  return /*#__PURE__*/_jsx(StackedIcon, {
    className: notificationIconStyles,
    icons: icons
  });
};
const contentStyles = css`
  flex: 1;
  font-size: 0.875rem;

  ul {
    list-style-position: outside;
    list-style-type: disc;
    padding-left: 1rem;
    word-break: break-word;

    [dir='rtl'] & {
      padding-left: 0;
      padding-right: 1rem;
    }
  }
`;
export const Content = _ref5 => {
  let {
    children
  } = _ref5;
  return /*#__PURE__*/_jsx("div", {
    className: contentStyles,
    children: children
  });
};